var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "24px",
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3D74BC0A-676A-497E-AB46-7FA5BAB0B3A4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01.home-aba/concursos",
    transform: "translate(-24.000000, -345.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu-principal",
    transform: "translate(24.000000, 232.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-trilhas",
    transform: "translate(0.000000, 113.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    fillOpacity: 0,
    fill: "#F5F5F5",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,1 C6.56360882,1 5.40642491,1.21039707 4.50360932,1.57152331 C3.90748509,1.809973 3.51247012,2.07331631 3.29289322,2.29289322 C3.10535684,2.4804296 3,2.73478351 3,3 L3,15 C3,15.8521699 3.98551359,16.2974338 4.62252676,15.7832252 L4.70710678,15.7071068 C4.73752988,15.6766837 4.90501491,15.565027 5.24639068,15.4284767 C5.90607509,15.1646029 6.81139118,15 8,15 C9.01970503,15 9.7741063,15.1984053 11.3276876,15.8090897 L12.2904589,16.188069 C13.8509151,16.7851063 14.7500911,17 16,17 C17.4363912,17 18.5935751,16.7896029 19.4963907,16.4284767 C20.0925149,16.190027 20.4875299,15.9266837 20.7071068,15.7071068 C20.8946432,15.5195704 21,15.2652165 21,15 L21,3 C21,2.14783014 20.0144864,1.70256618 19.3774732,2.21677482 L19.2928932,2.29289322 C19.2624701,2.32331631 19.0949851,2.434973 18.7536093,2.57152331 C18.0939249,2.83539707 17.1886088,3 16,3 C14.980295,3 14.2258937,2.80159468 12.6723124,2.19091025 L11.7095411,1.81193096 C10.1490849,1.21489368 9.24990889,1 8,1 Z M8,3 C9.01970503,3 9.7741063,3.19840532 11.3276876,3.80908975 L12.2904589,4.18806904 C13.8509151,4.78510632 14.7500911,5 16,5 L16.3532954,4.99565126 C17.2799814,4.97255005 18.0834954,4.85814894 18.7711968,4.67012734 L19,4.603 L19,14.463 L18.9776121,14.4746584 C18.913429,14.504804 18.8389533,14.5373857 18.7536093,14.5715233 C18.0939249,14.8353971 17.1886088,15 16,15 C14.980295,15 14.2258937,14.8015947 12.6723124,14.1909103 L11.7095411,13.811931 C10.1490849,13.2148937 9.24990889,13 8,13 L7.64670465,13.0043487 C6.72001856,13.02745 5.91650464,13.1418511 5.22880318,13.3298727 L5,13.396 L5,3.536 L5.02238791,3.52534156 C5.08657096,3.49519599 5.16104673,3.46261427 5.24639068,3.42847669 C5.90607509,3.16460293 6.81139118,3 8,3 Z",
    id: "Path",
    fill: "#1717CE",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,14 C4.51283584,14 4.93550716,14.3860402 4.99327227,14.8833789 L5,15 L5,22 C5,22.5522847 4.55228475,23 4,23 C3.48716416,23 3.06449284,22.6139598 3.00672773,22.1166211 L3,22 L3,15 C3,14.4477153 3.44771525,14 4,14 Z",
    id: "Path",
    fill: "#1717CE",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBound);
export default __webpack_public_path__ + "static/media/ic-bound.10a54e74405e37abe8e275807f0aaf87.svg";
export { ForwardRef as ReactComponent };